function formatCountLabel(count, singularLabel, pluralLabel) {
  return `${count} ${count === 1 ? singularLabel : pluralLabel}`;
}

export function formatPackagePrice(price, language, freeLabel) {
  if (price === 0) {
    return freeLabel;
  }

  return new Intl.NumberFormat(language, {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(price);
}

export function getPackageShortDescription(pkg, t) {
  return t(`packages.${pkg.id}.shortDesc`, {
    defaultValue: pkg.shortDesc || pkg.name,
  });
}

export function getStorageLabel(pkg, t) {
  if (pkg.storageType === 'memory') {
    return t('comparison.value.browserStorage', {
      defaultValue: '30 min in browser',
    });
  }

  const value = pkg.limits?.storageRetentionDays;
  if (value === null) {
    return t('comparison.value.unlimited', {
      defaultValue: 'Unlimited',
    });
  }

  if (!value) {
    return null;
  }

  if (value % 365 === 0) {
    const years = value / 365;
    if (years === 1) {
      return t('comparison.value.year', {
        defaultValue: '1 year',
      });
    }

    return t('comparison.value.years', {
      count: years,
      defaultValue: '{{count}} years',
    });
  }

  return t('comparison.value.days', {
    count: value,
    defaultValue: '{{count}} days',
  });
}

export function getPackageHighlights(pkg, t) {
  const limits = pkg.limits || {};
  const highlights = [];

  if (limits.maxRecipients > 0) {
    highlights.push(
      formatCountLabel(
        limits.maxRecipients,
        t('pricing.labels.recipientOne', { defaultValue: 'recipient' }),
        t('pricing.labels.recipientOther', { defaultValue: 'recipients' }),
      ),
    );
  }

  if (limits.maxEvents > 0) {
    highlights.push(
      formatCountLabel(
        limits.maxEvents,
        t('pricing.labels.eventOne', { defaultValue: 'event' }),
        t('pricing.labels.eventOther', { defaultValue: 'events' }),
      ),
    );
  }

  if (limits.maxMessages > 0) {
    highlights.push(
      formatCountLabel(
        limits.maxMessages,
        t('pricing.labels.messageOne', { defaultValue: 'message' }),
        t('pricing.labels.messageOther', { defaultValue: 'messages' }),
      ),
    );
  }

  if (limits.maxVideos > 0 && highlights.length < 5) {
    highlights.push(
      formatCountLabel(
        limits.maxVideos,
        t('pricing.labels.videoOne', { defaultValue: 'video message' }),
        t('pricing.labels.videoOther', { defaultValue: 'video messages' }),
      ),
    );
  }

  if (limits.maxTemplates > 0 && highlights.length < 5) {
    highlights.push(
      formatCountLabel(
        limits.maxTemplates,
        t('pricing.labels.templateOne', { defaultValue: 'template' }),
        t('pricing.labels.templateOther', { defaultValue: 'templates' }),
      ),
    );
  }

  const storageLabel = getStorageLabel(pkg, t);
  if (storageLabel && highlights.length < 5) {
    highlights.push(storageLabel);
  }

  return highlights.slice(0, 5);
}
